import React from "react"
import {ConfirmationModal} from "../../ConfirmationModal/ConfirmationModal"

interface CancelRiskSettingsConfirmationModalProps {
	close: () => void
	onSubmit: () => void
}
export default function CancelRiskSettingsConfirmationModal({
	close,
	onSubmit,
}: CancelRiskSettingsConfirmationModalProps) {
	return (
		<ConfirmationModal
			close={close}
			onSubmit={onSubmit}
			title="You have unsaved changes"
			cancelButtonText="Keep editing"
			cancelButtonClassname="button is-white"
			okButtonText="Leave without saving"
			okButtonClassname="button is-danger is-outlined"
		>
			The changes you made will not be saved, are you sure you wish to proceed?
		</ConfirmationModal>
	)
}
